import { render, staticRenderFns } from "./WDStepTitle.vue?vue&type=template&id=161ad068&"
import script from "./WDStepTitle.vue?vue&type=script&lang=js&"
export * from "./WDStepTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports